package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.dashboard.DashboardScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.title_dashboard
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteDashboard : RouteParameterTo

object RouterDashboard : RouterNoParameters<RouteDashboard>(RouteDashboard::class) {
    override fun routeFrom(parameters: RouteDashboard) = "/dashboard"

    @Composable
    override fun Show(parameters: RouteDashboard) {
        RouteDashboardImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteDashboard,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteDashboard

    override fun isMatching(route: String) = route == "/dashboard"

    override fun navigateFrom(path: String) = RouteDashboard
}

class RouteDashboardImpl : Route<RouteDashboard>(
    route = "/dashboard",
    params = RouteDashboard,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        LaunchedEffect(Unit) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.title_dashboard,
                    listOf(
                        MenuItem.MenuItemSimple(
                            imageVector = Icons.Rounded.Logout,
                            onClick = { appModel.logout() }
                        )
                    )
                )
            )
        }

        state.apiProvider?.apiNormal?.let { api ->
            DashboardScreen()
        }
    }
}
